import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

const TypesSection = styled.section`
  padding: 100px 0;
  background-color: #fff;
  
  .section-title {
    text-align: center;
    margin-bottom: 60px;
    
    h2 {
      font-size: 2.5rem;
      font-weight: 700;
      color: #333;
      margin-bottom: 20px;
      
      span {
        color: #2e7d32;
      }
    }
    
    p {
      color: #666;
      font-size: 1.1rem;
      max-width: 700px;
      margin: 0 auto;
    }
  }
  
  .type-card {
    height: 100%;
    border: none;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
      
      .card-img-top {
        transform: scale(1.05);
      }
    }
    
    .card-img-wrapper {
      height: 200px;
      overflow: hidden;
      
      .card-img-top {
        height: 100%;
        width: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
      }
    }
    
    .card-body {
      padding: 30px;
    }
    
    .card-title {
      font-weight: 700;
      font-size: 1.4rem;
      margin-bottom: 15px;
      color: #333;
    }
    
    .card-text {
      color: #666;
      font-size: 1rem;
      line-height: 1.6;
      margin-bottom: 20px;
    }
    
    .land-features {
      padding-left: 0;
      list-style: none;
      margin-bottom: 0;
      
      li {
        margin-bottom: 10px;
        display: flex;
        align-items: flex-start;
        
        svg {
          color: #2e7d32;
          margin-right: 10px;
          margin-top: 4px;
        }
      }
    }
  }
`;

const LandTypes = () => {
  const landTypes = [
    {
      title: "Vacant Land",
      image: "/images/vacant_land_600x350.jpg",
      description: "Raw, undeveloped land in various sizes, from small parcels to large acreage.",
      features: [
        "Rural and remote properties",
        "Subdivision lots",
        "Infill lots in urban/suburban areas"
      ]
    },
    {
      title: "Recreational Land",
      image: "/images/recreational_land_600x350.jpg",
      description: "Properties suitable for outdoor activities and recreational use.",
      features: [
        "Hunting land",
        "Camping and hiking properties",
        "Land with trails or water features"
      ]
    },
    {
      title: "Agricultural Land",
      image: "/images/agricultural_land_600x350.jpg",
      description: "Land suited for farming, ranching, or other agricultural purposes.",
      features: [
        "Farmland and crop fields",
        "Pasture and grazing land",
        "Orchards and vineyards"
      ]
    },
    {
      title: "Development Land",
      image: "/images/development_land_600x350.jpg",
      description: "Properties with potential for residential, commercial, or industrial development.",
      features: [
        "Land zoned for residential development",
        "Commercial parcels",
        "Industrial or mixed-use properties"
      ]
    }
  ];

  return (
    <TypesSection id="land-types">
      <Container>
        <div className="section-title">
          <h2>Types of Land We <span>Buy</span></h2>
          <p>
            We purchase a variety of land properties throughout the United States, including:
          </p>
        </div>
        
        <Row className="g-4">
          {landTypes.map((type, index) => (
            <Col key={index} md={6} lg={3}>
              <Card className="type-card">
                <div className="card-img-wrapper">
                  <Card.Img variant="top" src={type.image} alt={type.title} />
                </div>
                <Card.Body>
                  <Card.Title>{type.title}</Card.Title>
                  <Card.Text>{type.description}</Card.Text>
                  <ul className="land-features">
                    {type.features.map((feature, idx) => (
                      <li key={idx}>
                        <FontAwesomeIcon icon={faCheck} />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </TypesSection>
  );
};

export default LandTypes;
